import { render, staticRenderFns } from "./vIngredientNutrientQuantityInputRow.vue?vue&type=template&id=2b1c74cd&scoped=true"
import script from "./vIngredientNutrientQuantityInputRow.vue?vue&type=script&lang=ts"
export * from "./vIngredientNutrientQuantityInputRow.vue?vue&type=script&lang=ts"
import style0 from "./vIngredientNutrientQuantityInputRow.vue?vue&type=style&index=0&id=2b1c74cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c74cd",
  null
  
)

export default component.exports